var datePickersFunctions = (function ($) {
    var init = function () {
        Date.prototype.isValid = function () {
            return this.getTime() === this.getTime();
        };

        if ($.isFunction($(window).datepicker)) {
            var _today = new Date();

            // Date Picker - Default
            $('[data-toggle="datepicker"]').each(function () {
                $(this).datepicker({
                    format: "dd/mm/yyyy"
                });

                $(this).on('hide.datepicker', function (e) {
                    $(this).valid();
                });

            });

            // Date Picker - Only Past Dates
            $('[data-toggle="datepicker-past"]').each(function () {
                $(this).datepicker({
                    format: "dd/mm/yyyy",
                    endDate: _today
                })
            });

            // Date Picker - MM YYYY Format            
            $('[data-toggle="datepicker-mmyyyy"]').each(function () {
                if ($(this).data("enddate") !== undefined) {
                    var _endDate = new Date($(this).data("enddate"));
                    if (_endDate.isValid()) {
                        $(this).datepicker({
                            format: "mm/yyyy",
                            endDate: _endDate
                        });
                    }
                    else {
                        console.warn("Datepicker: End date is invalid, using default");
                        $(this).datepicker({
                            format: "mm/yyyy",
                        });
                    }
                }
                else {
                    $(this).datepicker({
                        format: "mm/yyyy",
                    });
                }                
            });

            // The date of a trainees annual appraisal can be brought forward by any amount of time, or delayed by up to two months
            $('[data-toggle="datepicker-ipd-appraisal"]').each(function () {
                if ($(this).data("appraisalduedate") !== undefined) {
                    var appraisalDueDate = new Date($(this).data("appraisalduedate"));
                    if (appraisalDueDate.isValid()) {
                        // Based on the original due date of the annual appraisal, only options within the allowed time frame,
                        // 2 months after the original deadline or no restriction on how far forward, will be made selectable on
                        // the calendar.Other dates will be unavailable for selection
                        var minDate = '';
                        var endDate = appraisalDueDate.setMonth(appraisalDueDate.getMonth() + 2)
                        if ($("#FirstAppraisalDate").length > 0) {
                            var datestring = $("#FirstAppraisalDate")[0].value;
                            if (datestring) {
                                let dt = datestring.split("/").reverse().join("/");
                                minDate = new Date(dt);
                                var currentDt = new Date();
                                if (minDate < currentDt) {
                                    minDate = currentDt;
                                }
                            }
                        }

                        $(this).datepicker({
                            inline: true,
                            container: ".ipd-appraisal-update-datepicker-container",
                            format: "dd/mm/yyyy",
                            endDate: endDate,
                            startDate: minDate
                        });
                    }
                }
            });
        }
        else {
            console.warn("Datepicker: Plugin not loaded");
        }
    };

    return {
        init: function () {
            init();
        }
    };
})(window.jQuery);

window.datePickersFunctions = datePickersFunctions;
datePickersFunctions.init();
